module.exports = __webpack_public_path__ + "static/media/comment-alt-heart.1c93bf73.svg";